<template>
	<div class="topDiv">
		<label class="teams-label-font">
			{{ label }}<span v-if="mandatory" class="asterik">*</span>
		</label>
		<quill-editor
			class="mt-2 custom-quill-editor p-0"
			:disabled="disabled"
			:type="type"
			:placeholder="placeholder"
			:id="id"
			v-model.trim="inputData"
			@input="handleInput"
			@blur="handleBlur"
			:class="{
				validationError: showError || showValidationError,
			}"
			:options="editorOption"
		>
		</quill-editor>
	</div>
</template>

<script>
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
export default {
	name: "CustomQuillEditor",
	components: {
		quillEditor,
	},
	props: {
		disabled: Boolean,
		mandatory: Boolean,
		showError: Boolean,
		type: String,
		label: String,
		placeholder: String,
		id: String,
		limit: Number,
		vmodel: {
			validator: function () {
				return true;
			},
		},
	},

	data() {
		return {
			inputData: "",
			editorOption: {
				modules: {
					toolbar: [
						["bold", "italic", "underline"],
						[
							{
								list: "ordered",
							},
							{
								list: "bullet",
							},
						],
					],
				},
				preserveWhitespace: true,
				placeholder: this.placeholder,
			},
			showValidationError: false,
		};
	},

	created() {
		if (this.vmodel) {
			this.inputData = this.vmodel;
		}
	},
	watch: {
		inputData(newValue) {
			this.validateInput(newValue);
		},
	},
	methods: {
		validateInput(value) {
			if (this.mandatory && !value.trim()) {
				this.showValidationError = true;
			} else if (this.limit && value.length > parseInt(this.limit)) {
				this.showValidationError = true;
			} else {
				this.showValidationError = false;
			}
		},
		handleInput() {
			let processedInput = this.inputData.replace(/^(<p><br><\/p>)+/, "");
			this.inputData = processedInput.trim();
			this.$emit("select-value", this.inputData);
			this.$emit("handle-input");
		},

		handleBlur() {
			this.$emit("handle-blur");
		},
	},
};
</script>

<style>
.validationError {
	border: 1px solid red !important;
}
</style>
